/**
 * Compteurs d'abonnés des canaux Villopia (Discord, YouTube, TikTok).
 *
 * La CSP interdit toute requête sortante depuis le client : les trois plateformes
 * se lisent côté serveur (`social-stats`, cache d'une heure par isolat), et le jeu
 * ne parle qu'à Supabase. Un compteur inconnu vaut `null` et le client le MASQUE :
 * afficher « 0 abonné » sur un simple échec de lecture serait un mensonge triste.
 */

import { getSupabase, isSupabaseConfigured } from './supabase';

export interface SocialCounts {
  readonly discord: number | null;
  readonly youtube: number | null;
  readonly tiktok: number | null;
}

function countOf(value: unknown): number | null {
  return typeof value === 'number' && Number.isFinite(value) && value > 0 ? value : null;
}

export async function fetchSocialCounts(): Promise<SocialCounts | null> {
  if (!isSupabaseConfigured()) return null;
  try {
    const response: { data: unknown; error: unknown } =
      await getSupabase().functions.invoke('social-stats');
    if (response.error !== null || typeof response.data !== 'object' || response.data === null) {
      return null;
    }
    const data = response.data as Record<string, unknown>;
    return {
      discord: countOf(data.discord),
      youtube: countOf(data.youtube),
      tiktok: countOf(data.tiktok),
    };
  } catch {
    return null;
  }
}
